/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-11-26                                                        *
 ******************************************************************************/

export default {
    props: {
        dataStoreName: {
            type: String
        },
        dataStoreQuery: {
            type: Object
        },
        dataInitialLoad:{
            type: Boolean,
            default: true
        }
    },
    provide(){
        return{
            setItems: this.setItems,
            registerItemsReceiver: this.registerItemsReceiver,
            registerDataSource:this.registerDataSource,
        };
    },
    data(){
        return {
            items:[],
            items_receivers:[],
            items_data_source: null,
            itemsLength:0,
            first_search_completed: false,
            items_rendering: false
        };
    },
    computed:{
        router_merged_data_store_query(){
            return {...this.dataStoreQuery,...this.$route.query};
        }
    },
    methods:{
        registerItemsReceiver(component){
            this.items_receivers.push(component);
        },
        beginItemsRendering(){
            this.items_rendering = true;
        },
        finishItemsRendering(){
            this.items_rendering = false;
        },
        finishItemsRenderingAfterPaint(){
            this.$nextTick(()=>{
                if(typeof window !== 'undefined' && window.requestAnimationFrame){
                    window.requestAnimationFrame(()=>{
                        window.requestAnimationFrame(()=>{
                            this.finishItemsRendering();
                        });
                    });
                }else{
                    setTimeout(()=>{
                        this.finishItemsRendering();
                    });
                }
            });
        },
        setItems(items){
            this.$emit('items-loaded',items);
            this.first_search_completed = true;
            this.items = items;
            this.itemsLength = items.length;
            this.items_receivers.forEach((component)=>{
                component.setItems(items);
            });
            this.finishItemsRenderingAfterPaint();
        },
        registerDataSource(data_source){
            this.items_data_source = data_source;
        }
    }
}
